import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { SicotService } from '../sicot.service';
import { DEFAULT_BUNDLE } from './default-bundle';

@Component({
  selector: 'app-nuova-richiesta-valutazione',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
  ],
  templateUrl: './nuova-richiesta-valutazione.component.html',
  styleUrl: './nuova-richiesta-valutazione.component.css',
})
export class NuovaRichiestaValutazioneComponent implements OnInit {
  private readonly sicot = inject(SicotService);
  private readonly snackBar = inject(MatSnackBar);

  bundleJson = '';
  sending = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  jsonError: string | null = null;

  ngOnInit(): void {
    this.caricaTemplate();
  }

  caricaTemplate(): void {
    this.bundleJson = JSON.stringify(DEFAULT_BUNDLE, null, 2);
    this.errorMessage = null;
    this.successMessage = null;
    this.jsonError = null;
  }

  formatta(): void {
    this.jsonError = null;
    try {
      const parsed = JSON.parse(this.bundleJson);
      this.bundleJson = JSON.stringify(parsed, null, 2);
      this.snackBar.open('JSON formattato.', undefined, { duration: 2000 });
    } catch (e) {
      this.jsonError = e instanceof Error ? e.message : 'JSON non valido';
    }
  }

  valida(): boolean {
    this.jsonError = null;
    try {
      JSON.parse(this.bundleJson);
      this.snackBar.open('JSON valido.', undefined, { duration: 2000 });
      return true;
    } catch (e) {
      this.jsonError = e instanceof Error ? e.message : 'JSON non valido';
      return false;
    }
  }

  invia(): void {
    this.errorMessage = null;
    this.successMessage = null;
    this.jsonError = null;

    let bundle: object;
    try {
      bundle = JSON.parse(this.bundleJson) as object;
    } catch (e) {
      this.jsonError = e instanceof Error ? e.message : 'JSON non valido';
      return;
    }

    if (!bundle || typeof bundle !== 'object') {
      this.jsonError = 'Il contenuto non è un oggetto JSON valido.';
      return;
    }

    this.sending = true;
    this.sicot.postRichiestaValutazioneAssistito(bundle).subscribe({
      next: (res: unknown) => {
        this.sending = false;
        const body = res as Record<string, unknown>;
        const operationId = body?.['id'] ?? body?.['operationId'];
        if (operationId) {
          this.successMessage = `Richiesta inviata. Operation ID: ${operationId}`;
        } else {
          this.successMessage = 'Richiesta inviata con successo.';
        }
        this.snackBar.open('Richiesta inviata.', undefined, { duration: 3000 });
      },
      error: (err) => {
        this.sending = false;
        const msg = err?.error?.message ?? err?.error?.issue?.[0]?.details?.text ?? err?.message ?? 'Errore durante l\'invio';
        this.errorMessage = typeof msg === 'string' ? msg : JSON.stringify(msg);
      },
    });
  }
}
